export const toDegrees = (angle: number): number => {
  return angle * (180 / Math.PI);
};

export const toRadians = (angle: number): number => {
  return angle * (Math.PI / 180);
};
